import { useTranslation } from 'react-i18next';

import classes from './TotalFares.module.css';

const TotalFares = (props) => {
    const {t} = useTranslation();

    if (!props.total) {
        return null;
    }
    return (
        <div className={classes.Calulations}>
            <ul>
                <li>
                    <span className={classes.CauluationIcon} >
                        <i className="fa-solid fa-clock"></i>
                    </span>
                    {t('booking.calculation.time')}: {props.durationText}
                </li>
                <li>
                    <span className={classes.CauluationIcon}>
                        <i className="fa-solid fa-route"></i>
                    </span>
                    {t('booking.calculation.distance')}: {props.distanceText} 
                </li>
                <li>
                    <span className={classes.CauluationIcon}>
                        <i className="fa-solid fa-money-check-dollar"></i>
                    </span>
                    {t('booking.calculation.total')}: {props.total.toFixed(2)}
                </li>
            </ul>
        </div>
    ); 
}

export default TotalFares;